import {
    useLocation,
    Navigate,
    Outlet,
} from "react-router-dom";
import { useEffect } from "react";

const RequireAuth = ({ allowedRoles }) => {
    const location = useLocation();
    const token = localStorage.getItem("xsrfToken");
    const roleRaw = localStorage.getItem("rUser");
    const tAuth = Boolean(token);
    const rAuth = roleRaw != null ? String(roleRaw).trim() : "";
    const allowed =
        String(allowedRoles ?? "").trim() === rAuth;

    useEffect(() => {
        if (tAuth || !process.env.REACT_APP_INTERIM_LOGIN) {
            return;
        }
        const loginUrl =
            process.env.REACT_APP_INTERIM_LOGIN +
            "?redirect=" +
            encodeURIComponent(location.pathname + location.search);
        window.location.assign(loginUrl);
    }, [tAuth, location.pathname, location.search]);

    if (!tAuth) {
        return null;
    }

    if (!allowed) {
        return (
            <Navigate
                to="/unauthorized"
                state={{ from: location }}
                replace
            />
        );
    }

    return <Outlet />;
};

export default RequireAuth;